import { useEffect, useState } from 'react';
import { api } from '../contexts/AuthContext';

export const fmtMoney = (v) =>
  v === null || v === undefined || v === ''
    ? '—'
    : `₪${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export const PAYMENT_METHODS = ['Bank', 'Cash', 'Cheque', 'Transfer', 'Card'];
export const DEPOSIT_SOURCES = ['Transfer', 'Cash', 'Cheque'];

// Fetch app users for the "owner" picker. Gracefully returns [] when forbidden (non-admins).
export function useUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get('/users')
      .then((r) => { if (alive) setUsers(r.data.users || []); })
      .catch(() => { if (alive) setUsers([]); });
    return () => { alive = false; };
  }, []);
  return users;
}

export const todayStr = () => new Date().toISOString().slice(0, 10);

// Per-shipment payment math (with legacy fallback: customerPaid used as the charge).
export const shipmentFinance = (r) => {
  const requested = Number(r.amountRequested ?? r.customerPaid ?? 0) || 0;
  const paid = Number(r.amountPaid ?? 0) || 0;
  const left = Math.round((requested - paid) * 100) / 100;
  let status = 'UNPAID';
  if (requested > 0 && paid >= requested - 0.01) status = 'PAID';
  else if (paid > 0.01) status = 'PARTIAL';
  return { requested, paid, left, status };
};

export const PAY_STATUS_TONE = { PAID: 'emerald', PARTIAL: 'warning', UNPAID: 'danger' };
